export default "__VITE_ASSET__DKCkqi07__"